import React, { useEffect, useState } from 'react';
import { getCurrentAppState } from './components/AlmeApp/AlmeAppState';
import AlmeApp from './components/AlmeApp/AlmeApp';
import { defaultTenant, getTenantByAccessKey } from './components/AlmeTenantSelector/AlmeTenants';
import './fontAwesome';
import './assets/styles/styles.css';
import { ThemeWrapper } from './components/AlmeTenantSelector/ThemeWrapper';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { getTenantName } from './components/AlmeUtilities/Alme-utils';
const determineTenant = (props) => {
    let tenant = defaultTenant;
    const currentAppState = getCurrentAppState();
    if (props.appConfig.main.platform === "VISTA" && currentAppState.accessKey) {
        const vistaUserMetadata = props.appConfig.main.userMetadata;
        if (vistaUserMetadata && Array.isArray(vistaUserMetadata.platformInformation)) {
            vistaUserMetadata.platformInformation.forEach(element => {
                if (vistaUserMetadata.currentEnterpriseId === element.enterpriseId) {
                    tenant = getTenantName(element);
                    props.appConfig.main.appAccessKey = tenant.value;
                }
            });
        }
    }
    else {
        if (props.appConfig.main.appAccessKey) {
            tenant = getTenantByAccessKey(props.appConfig.main.appAccessKey);
        }
    }
    return tenant || defaultTenant;
};
const App = (props) => {
    const tenantValue = determineTenant(props);
    const [tenant, setTenant] = useState(tenantValue);
    const appConfig = Object.assign(Object.assign({}, props.appConfig), { clientName: tenant.name.toLowerCase() });
    appConfig.setTenant = setTenant;
    useEffect(() => {
        function onResize() {
            document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
            document.documentElement.style.setProperty('--sw', `${document.body.offsetWidth - document.body.clientWidth}px`);
        }
        window.addEventListener("resize", onResize);
        onResize();
    }, []);
    /**
     * Theme provider requires a non null value, so assigning default theme if app not initialized
     */
    return (React.createElement(ErrorBoundary, { appConfig: appConfig },
        React.createElement(ThemeWrapper, { tenant: tenant, platform: appConfig.main.platform, uiLogLevel: appConfig.UiLogLevel },
            React.createElement(AlmeApp, { isOpen: props.isOpen, onClose: props.onClose, onMinimize: props.onMinimize, appConfig: appConfig }))));
};
export default App;
